const AuthProvider = {
  // login dipanggil saat user submit login form
  login: ({ username, password }) => {
    const API_BASE = process.env.REACT_APP_API_BASE;
    const request = new Request(API_BASE+"/login.php", {
      method: "POST",
      body: JSON.stringify({ username, password }),
      headers: new Headers({ "Content-Type": "application/json" }),
    });

    
    
    return fetch(request)
      .then((response) => {
        if (response.status < 200 || response.status >= 300) {
          throw new Error(response.statusText);
        }
        return response.json();
      })
      .then((data) => {
        if (!data.success) {
          throw new Error(data.message || "Login gagal");
        }
        localStorage.setItem("token", data.token);
      });
  },

  // logout dipanggil saat user klik logout
  logout: () => {
    localStorage.removeItem("token");
    return Promise.resolve();
  },

  // checkAuth dipanggil saat route butuh login
  checkAuth: async () => {
    const token = localStorage.getItem("token");
    if (!token) return Promise.reject();

    try {
      const API_BASE = process.env.REACT_APP_API_BASE;
      const res = await fetch(`${API_BASE}/check-token.php`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (!res.ok) {
        localStorage.removeItem("token");
        return Promise.reject();
      }

      return Promise.resolve();
    } catch (error) {
      console.error("Auth check failed:", error);
      localStorage.removeItem("token");
      return Promise.reject();
    }
  },


  // checkError dipanggil jika API balikin error
  checkError: (error) => {
    const status = error.status;
    if (status === 401 || status === 403) {
      localStorage.removeItem("token");
      return Promise.reject();
    }
    return Promise.resolve();
  },

  // getPermissions dipanggil jika mau role-based access
  getPermissions: () => Promise.resolve(),
};

export default AuthProvider;
